import { useState, useEffect } from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import axios from 'axios';
import qs from 'qs';
import ApexCharts from 'react-apexcharts';
import { addSpace } from '../Components/Tools';


const Page7GraphsParHypothese = (props) =>
{

    const blue = '#069BD3';
    const height = props.height || 800;
    const width = props.width || 1200;
    const fontsize = (height*12/890);
    const sizelogo = width/6;

    const [graph1Series, setGraph1Series] = useState(undefined);
    const [graph1Options, setGraph1Options] = useState(undefined);
    const [graph2Series, setGraph2Series] = useState(undefined);
    const [graph2Options, setGraph2Options] = useState(undefined);

    useEffect(() => {
        fetchCapitalStockeByModality();
        fetchCapitalStockeByAxeIntervention();
    }, [props.hypothese]);

    const fetchCapitalStockeByModality = () => {

        if (!props.user?.id_budget) {
            return;
        }

        if (!props.hypothese) {
            return;
        }

        // Convertir le numéro hypothèse (1,2,3) en h1, h2, h3
        const hypotheseKey = `h${props.hypothese}`;

        const params = {
            capitalStockeByModalityOfPortage: true,
            id_budget: props.user.id_budget,
            hypothese: hypotheseKey,
            debut: props.user.config_budget.prosp_an_deb,
            fin: props.user.config_budget.prosp_an_fin,
            id_organisme: props.user.id_organisme
        };
        console.log('Envoi des paramètres pour Graph 1:', params);

        axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify(params))
        .then(response => {
            console.log('Réponse reçue pour Graph 1:', response.data);
            if (response.data.status === 1) {
                const data = response.data.data;
                
                // Nouvelle structure: [année, [id, modalite, montant], [id, modalite, montant], ...]
                // Créer une structure pour avoir une série par modalité
                const annees = [];
                const modalitesMap = {}; // { id: { nome, data: [...], color } }
                
                // Parcourir chaque année
                data.forEach(anneeData => {
                    const annee = anneeData[0];
                    annees.push(annee);
                    
                    // Parcourir les modalités de cette année (à partir de l'index 1)
                    for (let i = 1; i < anneeData.length; i++) {
                        const [id, modalite, montant] = anneeData[i];
                        
                        if (!modalitesMap[id]) {
                            modalitesMap[id] = {
                                name: modalite,
                                data: []
                            };
                        }
                        modalitesMap[id].data.push(montant);
                    }
                });
                
                // Assurer que chaque modalité a une valeur pour chaque année
                const allModaliteIds = Object.keys(modalitesMap).map(Number).sort((a, b) => a - b);
                const series = allModaliteIds.map(id => ({
                    name: modalitesMap[id].name,
                    data: modalitesMap[id].data
                }));

                // Palette de couleurs
                const colors = [
                    '#069BD3', '#59B44A', '#6571FE', '#FF6B6B', '#FFA500',
                    '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD',
                    '#20B2AA', '#FFB6C1', '#87CEEB', '#F0E68C', '#FF69B4'
                ];

                const options = {
                    chart: {
                        type: 'bar',
                        stacked: true,
                        height: props.height * 0.7,
                        toolbar: {
                            show: false
                        }
                    },
                    title: {
                        text: 'Capital Stocké par Modalité de Portage',
                        style: {
                            fontSize: fontsize + 4
                        }
                    },
                    xaxis: {
                        categories: annees.map(a => a.toString()),
                        labels: {
                            style: {
                                fontSize: fontsize
                            }
                        }
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return addSpace(Math.round(value*100)/100, true) + " €";
                            },
                            style: {
                                fontSize: fontsize
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    colors: colors.slice(0, series.length),
                    legend: {
                        position: 'bottom'
                    }
                };

                setGraph1Options(options);
                setGraph1Series(series);
            }
        })
        .catch(error => {
            if (error.response) {
                console.error('Erreur status:', error.response.status);
                console.error('Erreur data:', error.response.data);
            }
        });
    };

    const fetchCapitalStockeByAxeIntervention = () => {

        if (!props.user?.id_budget) {
            return;
        }

        if (!props.hypothese) {
            return;
        }

        // Convertir le numéro hypothèse (1,2,3) en h1, h2, h3
        const hypotheseKey = `h${props.hypothese}`;

        const params = {
            capitalStockeByAxeIntervention: true,
            id_budget: props.user.id_budget,
            hypothese: hypotheseKey,
            debut: props.user.config_budget.prosp_an_deb,
            fin: props.user.config_budget.prosp_an_fin
        };

        axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify(params))
        .then(response => {
            if (response.data.status === 1) {
                const data = response.data.data;
                
                // Nouvelle structure: [année, [id, axe, montant], [id, axe, montant], ...]
                // Créer une structure pour avoir une série par axe
                const annees = [];
                const axesMap = {}; // { id: { name, data: [...], color } }
                
                // Parcourir chaque année
                data.forEach(anneeData => {
                    const annee = anneeData[0];
                    annees.push(annee);
                    
                    // Parcourir les axes de cette année (à partir de l'index 1)
                    for (let i = 1; i < anneeData.length; i++) {
                        const [id, axe, montant] = anneeData[i];
                        
                        if (!axesMap[id]) {
                            axesMap[id] = {
                                name: axe,
                                data: []
                            };
                        }
                        axesMap[id].data.push(montant);
                    }
                });
                
                // Assurer que chaque axe a une valeur pour chaque année
                const allAxeIds = Object.keys(axesMap).map(Number).sort((a, b) => a - b);
                const series = allAxeIds.map(id => ({
                    name: axesMap[id].name,
                    data: axesMap[id].data
                }));

                // Palette de couleurs
                const colors = [
                    '#069BD3', '#59B44A', '#6571FE', '#FF6B6B', '#FFA500',
                    '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD',
                    '#20B2AA', '#FFB6C1', '#87CEEB', '#F0E68C', '#FF69B4'
                ];

                const options = {
                    chart: {
                        type: 'bar',
                        stacked: true,
                        height: props.height * 0.7,
                        toolbar: {
                            show: false
                        }
                    },
                    title: {
                        text: 'Capital Stocké par Axe d\'Intervention',
                        style: {
                            fontSize: fontsize + 4
                        }
                    },
                    xaxis: {
                        categories: annees.map(a => a.toString()),
                        labels: {
                            style: {
                                fontSize: fontsize
                            }
                        }
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return addSpace(Math.round(value*100)/100, true) + " €";
                            },
                            style: {
                                fontSize: fontsize
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    colors: colors.slice(0, series.length),
                    legend: {
                        position: 'bottom'
                    }
                };

                setGraph2Options(options);
                setGraph2Series(series);
            }
        })
        .catch(error => {
            if (error.response) {
                console.error('Erreur status Graph 2:', error.response.status);
                console.error('Erreur data Graph 2:', error.response.data);
            }
        });
    };

    return (
        <div style={{width: '100%', height: '100%', padding: 20}}>

            {/* Header */}
            <div style={{display: 'flex', height: '15%'}}>
                <div style={{flex: 0.4, display: 'flex', marginLeft: 10}}>
                {props.logo && (
                    <img style={{maxHeight: height/8, borderRadius: 5}} src={props.logo} alt="Logo" />
                )}
                </div>

                <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: blue, fontSize: (fontsize+10)}}>Graphiques</p>
                    <p style={{color: blue, fontSize: (fontsize+6), marginLeft: 5, fontStyle: 'italic'}}>{props.hypothese !== null ? '(hypothèse '+props.hypothese+')' : ''}</p>
                </div>

                <div style={{flex: 0.4, display: 'flex', justifyContent: 'right', marginRight: 25}}>
                    <p style={{color: 'grey', fontSize: (fontsize+4)}}>Synthèse globale des opérations</p>
                </div>
            </div>


            {/* Container */}
            <div style={{flex: 1, height: '80%', fontSize: fontsize, overflowY: 'hidden', overflowX: 'hidden', paddingLeft: '20px', paddingRight: '20px', display: 'flex', gap: '20px'}}>
                
                {/* Graphique 1 - Capital Stocké par Modalité */}
                <div style={{flex: 1, border: '1px solid #ccc', borderRadius: '5px', padding: '10px'}}>
                    {graph1Options && graph1Series ? (
                        <ApexCharts
                            series={graph1Series}
                            options={graph1Options}
                            type="bar"
                            height={Math.max(300, height * 0.7)}
                        />
                    ) : (
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column'}}>
                            <p style={{color: '#999', fontSize: fontsize}}>Chargement...</p>
                        </div>
                    )}
                </div>

                {/* Graphique 2 - Capital Stocké par Axe d'Intervention */}
                <div style={{flex: 1, border: '1px solid #ccc', borderRadius: '5px', padding: '10px'}}>
                    {graph2Options && graph2Series ? (
                        <ApexCharts
                            series={graph2Series}
                            options={graph2Options}
                            type="bar"
                            height={Math.max(300, height * 0.7)}
                        />
                    ) : (
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column'}}>
                            <p style={{color: '#999', fontSize: fontsize}}>Chargement...</p>
                        </div>
                    )}
                </div>
                
            </div>
            
                        
            {/* Footer */}
            <div style={{display: 'flex', height: '5%', position: 'relative'}}>
                <div style={{position: 'absolute', bottom: 0, display: 'flex', marginLeft: 25, alignItems: 'center', width: 200}}>
                    <p style={{fontSize: (fontsize-2)}}>{props.date}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, left: '47%', display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{fontSize: fontsize}}>page : {props.pagination} / {props.countPageTotal}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, right: 0, display: 'flex', marginRight: 25, alignItems: 'center'}}>
                    <img style={{width: sizelogo}} src={Logo} />
                </div>
            </div>
            
        </div>
    );
}
  
  export default Page7GraphsParHypothese;
